import createVueApp from '@phoenix/createVueApp';
import SpecialModel from '@maison/components/organisms/slider/SpecialModel.vue';

document.querySelectorAll('.phoenix-special-model').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('SpecialModel', SpecialModel);
  app.mount(el);
});
